<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.table-seating-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}
.single-table-wrap {
  width: 33.33%;
  border-right: 1px solid #e2e2e2;
  min-height: 100%;
}
.single-table-wrap.no-border {
  border-right: none;
}
.single-table-wrap-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.attendee-catagory-wrapper {
  padding-right: 10px;
}
.single-attendee-catagory {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.attendee-catagory-wrapper ul li {
  padding: 10px 0;
  transition: all 0.4s;
}
.attendee-catagory-wrapper ul li:hover {
  background: #f8f8f8;
  transition: all 0.4s;
}
.attendee-searchbox {
  position: relative;
}
.search-icon-search-box {
  position: absolute;
  top: 50%;
  left: 24px;
  transform: translateY(-50%);
}
.attendee-searchbox .vs-input--icon{    top: 50%;
    transform: translateY(-50%);}
.searchbox .vs-input--placeholder.normal {
  padding: 0.7rem 10px 0.7rem 3.2rem !important;
}
.attendee-list-select-wrap .vs-list--item,
.attendee-catagory-drop-wrap .vs-list--item {
  border-bottom: none;
  padding: 8px 0;
  position: relative;
}
// .attendee-list-select-wrap .list-titles {
//   padding-left: 30px;
// }
.attendee-list-select-wrap .vs-list--slot {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.attendee-catagory-drop-wrap .vs-list {
    width: 100%;
    position: relative;
    padding: 0 0.75rem;
}
.attendee-catagory-drop-wrap .host-wrapper .vs-list--item,
.attendee-catagory-drop-wrap .guest-wrapper .vs-list--item {
  padding: 8px 15px !important;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: block;
  margin-bottom: 15px;
}
span.cross-btn {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.attendee-guest-list-wrap {
  height: 400px;
  overflow-y: scroll;
}

.attendee-list-wrap {
  height: 420px;
  overflow-y: scroll;
}
.bordered {
  border: 1px solid #f8b010;
}

.table-seating-wrapper {
    padding: 0 200px;
}
@media screen and (min-width:1367px) and (max-width: 1440px){
.table-seating-wrapper {
    padding: 0 80px;
}
}
@media screen and (max-width:1366px) {
.table-seating-wrapper {
    padding: 0 80px;
}
}
</style>
<template>
  <div id="page-attendee-add">
    <div class="header-custome">
      <h3>Pre-Assigned Table Seating</h3>
    </div>
    <vx-card>
      <div class="table-seating-wrapper">
        <div class="single-table-wrap">
          <!--<div class="single-table-wrap-top">
            <h5>Select Group</h5>-->
          <!--<vs-button color="primary" type="border">New</vs-button>-->
          <!--</div>
          <div class="attendee-catagory-wrapper mt-5">
            <ul>
              <li>
                <div class="single-attendee-catagory pl-3 active">
                  <p>All Attendees</p>
                  <p><feather-icon
                      class="iconsize"
                    icon="ChevronRightIcon"
                    />
                  </p>
                </div>
              </li>
            </ul>
          </div>-->
          <div class="single-table-wrap-top px-3 py-3">
            <h5>Drag and Drop Attendee(s) to your right</h5>
            <p>&nbsp;</p>
          </div>
          <div class="attendee-searchbox my-5 px-3">
            <vs-input
              icon="search"
              class="inputx w-full searchbox"
              placeholder="Search Attendee"
              v-model="attendeeName"
              @keyup="searchAttendee"
            />
            <!--<span class="search-icon-search-box">
                <feather-icon
                      class="iconsize"
                    icon="SearchIcon"
                    />
            </span>-->
          </div>
          <div class="attendee-list-select-wrap">
            <div class="attendee-list-wrap">
              <draggable
                :list="attendee_search_list"
                :move="checkMoveSelected"
                :group="{ name: 'people', pull: 'clone', put: false }"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in attendee_search_list"
                  :key="index"
                  :title="listItem.Name"
                  :subtitle="listItem.Email"
                >
                  <!--<vs-checkbox v-model="checkBox1"></vs-checkbox>-->
                </vs-list-item>
              </draggable>
            </div>
          </div>
        </div>
        <div class="single-table-wrap">
          <div class="single-table-wrap-top pl-3">
            <h5>Select Group</h5>
            <div class="button-group-area">
              <vs-button
                color="primary"
                type="border"
                size="small"
                class="mr-3"
                @click="$router.push('/event/roundtable/add')"
                >Add New</vs-button
              >
              <vs-button
                color="primary"
                type="border"
                size="small"
                @click="popupActive = true"
                >Bulk Import</vs-button
              >
            </div>
          </div>
          <div class="table-select-class px-3 mt-6">
            <div class="attendee-catagory-drop-wrap">
              <v-select
                placeholder="Select Topic"
                class="track-select"
                label="TopicName"
                v-model="topic"
                :options="TopicList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
            <br />
            <h5>Select Table</h5>
            <br />
            <v-select
              placeholder="Select Table"
              v-model="RoundTable"
              label="TableName"
              :options="roundtable_list"
              name="Table Name"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Table Name')"
              >{{ errors.first("Table Name") }}</span
            >
            <br />
          </div>

          <div class="attendee-catagory-drop-wrap">
            <vs-list class="mt-5">
              <div class="host-wrapper">
                <div class="attendee-table-select-head">
                  <h5>Host <span>(Max 1)</span></h5>
                </div>
                <div class="attendee-host-list-wrap">
                  <draggable
                    @change="checkLength('host')"
                    :list="host_list"
                    :move="checkOverflowGuest"
                    :group="{ name: 'people', put: hostPut }"
                    class="p-2 cursor-move mt-5"
                  >
                    <vs-list-item
                      v-for="(listItem, index) in host_list"
                      :key="index"
                      :title="listItem.Name"
                    >
                      <span
                        class="cross-btn"
                        @click="removeHost(listItem.AttendeeId)"
                        ><feather-icon class="iconsize" icon="XIcon"
                      /></span>
                    </vs-list-item>
                  </draggable>
                </div>
              </div>
            </vs-list>
          </div>
        </div>
        <div class="single-table-wrap no-border">
          <!--<div class="single-table-wrap-top pl-3">            
            <vs-button color="primary" type="border"  @click="$router.push('/event/roundtable/add')">Add New</vs-button>
          </div>-->
          <!--<div class="table-select-class px-3 mt-6">
            <v-select placeholder="Select Table" v-model="RoundTable" label="TableName" :options="roundtable_list" name="Table Name" v-validate="'required'" />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Table Name')"
            >{{ errors.first('Table Name') }}</span>
            <br>
          </div>-->
          <div class="attendee-catagory-drop-wrap pl-2">
            <vs-list class="mt-5">
              <div class="guest-wrapper">
                <div class="attendee-table-select-head">
                  Guests <span>(Max {{ maxGuest }})</span>
                </div>
                <div class="attendee-guest-list-wrap">
                  <draggable
                    @change="checkLength('guest')"
                    :list="guest_list"
                    :move="checkOverflowHost"
                    :group="{ name: 'people', put: guestPut }"
                    class="p-2 cursor-move mt-5"
                  >
                    <vs-list-item
                      :class="
                        attendeesonothertable.includes(listItem.AttendeeId)
                          ? 'bordered'
                          : 'normal'
                      "
                      v-for="(listItem, index) in guest_list"
                      :key="index"
                      :title="listItem.Name"
                    >
                      <span
                        class="cross-btn"
                        @click="removeGuest(listItem.AttendeeId)"
                        ><feather-icon class="iconsize" icon="XIcon"
                      /></span>
                    </vs-list-item>
                  </draggable>
                </div>
              </div>
            </vs-list>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="before_save"
                  >Save Changes</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-popup
      class="holamundo"
      title="Import Round Table"
      :active.sync="popupActive"
    >
      <div class="import-attendee-wrapper">
        <div class="template-download">
          <h4>Download the template</h4>
          <a
            color="primary"
            type="filled"
            class="mt-3 btn"
            href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_RoundTable.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
            >Download</a
          >
        </div>
        <div class="upload-file mt-5">
          <h4>Upload your file</h4>
          <div class="file-up-section">
            <p>Select XLSX file</p>
            <input
              type="file"
              id="roundtable_file"
              accept=".csv,.xlsx,.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <vs-button
              color="rgb(76, 139, 246)" type="filled"
              class="sub-btn"
              v-on:click="UploadRoundTable"
              >Upload</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// Store Module
import moduleroundtableManagementAdd from "@/store/roundtable-management/moduleRoundtableManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import ls from "@/common/localStorage";
import vSelect from "vue-select";
import draggable from "vuedraggable";
var vm;
export default {
  components: {
    //attendeeEditTabInformation,
    "v-select": vSelect,
    draggable,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxGuest: "11",
      topic: null,
      TopicList: [],
      roundtable_list: [],
      attendee_list: [],
      attendee_search_list: [],
      host_list: [],
      guest_list: [],
      activeTab: 0,
      RoundTable: null,
      attendeeName: null,
      hostPut: false,
      guestPut: false,
      popupActive: false,
      attendeesonothertable: [],
    };
  },
  watch: {
    topic(newVal) {
      //debugger;

      if (parseInt(newVal.TopicTableCapacity) != 0) {
        this.maxGuest = (parseInt(newVal.TopicTableCapacity) - 1).toString();
      } else {
        this.maxGuest = "0";
      }
      this.fetch_roundtables(newVal.TopicId);
      this.RoundTable = null;
      this.host_list = [];
      this.guest_list = [];
      console.log(newVal);
    },
    validateForm() {
      return !this.errors.any();
    },
    activeTab() {
      this.fetch_roundtable_data();
    },
    RoundTable(newVal) {
      if (newVal) this.getRoundtableSeatings(newVal);
      else {
        this.hostPut = false;
        this.guestPut = false;
      }
    },
    host_list() {
      this.checkLength("host");
    },
    guest_list() {
      this.checkLength("guest");
    },
  },
  methods: {
    fetch_roundtabletopics() {
      this.$store
        .dispatch("roundtableManagement/fetchRoundTableTopicDropdown")
        .then((res) => {
          this.TopicList = res;
          res.map((row) => {
            if (row.TopicName.includes("General")) vm.topic = row;
          });
          console.log(res);
        });
    },
    checkLength(field) {
      if (field == "guest") {
        //debugger;
        //this.guestPut = this.guest_list.length < 11 ? true : false;
        this.guestPut =
          this.guest_list.length < parseInt(this.maxGuest) ? true : false;
      } else {
        this.hostPut = this.host_list.length == 0 ? true : false;
      }
    },
    checkOverflowHost(evt) {
      //console.log(this.host_list.length)
      return this.host_list.length == 0 ? true : false;
    },
    checkOverflowGuest(evt) {
      return this.guest_list.length < parseInt(this.maxGuest) ? true : false;
    },
    checkMoveSelected: function (evt) {
      //console.log(this.host_list.length)
      let ID = evt.draggedContext.element.AttendeeId;
      let Name = evt.draggedContext.element.Name;
      let found = this.host_list.some((el) => el.AttendeeId === ID);
      let foundl = this.guest_list.some((el) => el.AttendeeId === ID);
      if (found || foundl) {
        return false;
      } else {
        this.checkUserOnOtherTable(ID, Name);
        return true;
      }
    },
    checkUserOnOtherTable(UserId, Name) {
      this.$store
        .dispatch("roundtableManagement/checkUserOnOtherTable", {
          TableId: this.RoundTable.TableId,
          UserId: UserId,
        })
        .then((res) => {
          if (res && res.length) {
            this.attendeesonothertable.push(UserId);
            this.$vs.notify({
              fixed: true,
              icon: "close",
              color: "warning",
              position: "bottom-center",
              title: Name,
              text: "Note: This user is pre-assigned to other table(s)",
            });
          }
        });
    },
    removeHost(id) {
      let index = this.host_list
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);

      this.host_list.splice(index, 1);
    },
    removeGuest(id) {
      let index = this.guest_list
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);

      this.guest_list.splice(index, 1);
    },
    searchAttendee() {
      let attendeeName = this.attendeeName.trim().toLowerCase();
      if (attendeeName) {
        this.attendee_search_list = this.attendee_list.filter((row) => {
          if (
            row.FirstName.toLowerCase().includes(attendeeName) ||
            row.LastName.toLowerCase().includes(attendeeName) ||
            row.Email.toLowerCase().includes(attendeeName)
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        this.attendee_search_list = this.attendee_list;
      }
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          resolve(result);
          if (result) vm.save_changes();
        });
      });
    },
    save_changes() {
      if (this.RoundTable && this.host_list.length) {
        this.$vs.loading();
        this.$store
          .dispatch("roundtableManagement/saveRoundtableSeatings", {
            RoundTable: this.RoundTable,
            host_list: this.host_list,
            guest_list: this.guest_list,
          })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Round Table Seating",
              text: "Round Table Seatings updated successfully.",
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Seating settings",
          text: "Host should be selected!",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    getRoundtableSeatings(Table) {
      if (Table) {
        this.$vs.loading();
        this.$store
          .dispatch("roundtableManagement/getRoundtableSeatings", Table.TableId)
          .then((res) => {
            this.host_list = res.Hosts;
            this.guest_list = res.Guests.sort((a, b) => {
              let fa = a.Name.toLowerCase(),
                fb = b.Name.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      }
    },
    fetch_roundtables(topicid) {
      //  alert(topicid);
      this.$store
        .dispatch("roundtableManagement/fetchRoundTables", topicid)
        .then((res) => {
          //debugger;
          this.roundtable_list = res.filter((row) => {
            return row.PreAssigned;
          });
          this.roundtable_list = this.roundtable_list.sort((a, b) => {
            let fa = a.TableName.toLowerCase(),
              fb = b.TableName.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
        });
    },
    fetch_attendees() {
      this.$store
        .dispatch("attendeeManagement/fetchAttendees", null)
        .then((res) => {
          this.attendee_search_list = this.attendee_list = res.filter((row) => {
            return row.IsPublished;
          });
          this.attendee_list = this.attendee_list.sort((a, b) => {
            let fa = a.FirstName.toLowerCase();
            let fb = b.FirstName.toLowerCase();
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
        });
    },
    UploadRoundTable: function () {
      var files = document.getElementById("roundtable_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "roundtable");
    },
  },
  created() {
    vm = this;
    // Register Module roundtableManagement Module
    if (!moduleroundtableManagementAdd.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleroundtableManagementAdd
      );
      moduleroundtableManagementAdd.isRegistered = true;
    }
    this.fetch_roundtables();
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    this.fetch_roundtabletopics();
    this.fetch_attendees();
  },
};
</script>